import { Component } from '@angular/core';

@Component({
  selector: 'no-changes',
  templateUrl: './no-changes.component.html'
})
export class NoChangesComponent {
  constructor() { }
}
